<mat-card>
    <mat-card-header>
        <mat-card-title>Drawdown Comparison</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <app-line-chart [series]="series"></app-line-chart>
    </mat-card-content>
</mat-card>
